import useQuery from "./useQuery";

export default function useActivationRangeDryRun(
  projectId: string,
  from: Date,
  to: Date,
  intervalSeconds: number | null,
) {
  const result = useQuery("/projects/:projectId(uuid)/analyses/activation/range/creation/dry-run", {
    routeParams: { projectId },
    query: { from, to, intervalSeconds: intervalSeconds ?? 0 },
    keepFresh: true,
    disabled: intervalSeconds === null,
    suspend: false,
  });

  if (result === undefined)
    return { emptySlotsWithAnalyses: null, emptySlotsWithCompliantAnalyses: null };
  return result.body;
}
